import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import COLORS from "../styled.constants";
import WorkList from "./WorkList";
import { products } from "../data";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import "swiper/css/bundle";

SwiperCore.use(Navigation);

function Work() {
  const PageTransition = styled(motion.div)``;
  const Title = styled.div`
    display: flex;
    color: ${COLORS.title};
    flex-direction: column;
    align-items: center;
    padding: 8rem;
    h2 {
      text-transform: uppercase;
      font-size: 2em;
      padding-bottom: 1rem;
    }
    .project-wrapper {
      text-align: center;
      /* background-color: yellow; */
    }

    @media screen and (max-width: 968px) {
      .project-wrapper {
      }
      h2 {
        font-size: 1.5em;
      }
    }
  `;

  const PlText = styled.div`
    font-size: 1.5em;
    color: ${COLORS.text};
    margin-bottom: 1rem;
    @media screen and (max-width: 968px) {
      font-size: 1.2em;
      width: 400px;
    }
  `;

  const ListWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 80%;
    .swiper-container {
      padding-top: 8rem;
      /* max-width: 100%; */
    }

    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      height: 50px;
      width: 50px;
      background-color: ${COLORS.button};
      z-index: 10;
      right: 60px;
      top: 0px;
      transform: translateY(50%);
      color: white;
      border-radius: 8px;
    }
    .swiper-button-next {
      right: 0;
    }
    .swiper-button-prev::after,
    .swiper-button-next::after {
      font-size: 2rem;
    }
    /* 
    /* @media only screen and (max-width: 600px) {
    } */

    @media screen and (max-width: 912px) {
      width: 400px;
      display: flex;
      justify-content: center;
    }
  `;

  return (
    <PageTransition
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Title>
        <div className="project-wrapper">
          <PlText>Some of my recent works</PlText>
          <h2>Projects</h2>
        </div>
        <ListWrapper>
          <Swiper
            spaceBetween={40}
            slidesPerView={1}
            navigation
            breakpoints={{
              968: {
                slidesPerView: 1,
              },
              1200: {
                slidesPerView: 2,
              },
            }}
          >
            {products.map((product) => {
              return (
                <SwiperSlide key={product.id}>
                  <WorkList
                    key={product.id}
                    img={product.img}
                    link={product.link}
                    alt={product.alt}
                    title={product.title}
                    text={product.text}
                    desc={product.desc}
                    github={product.github}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </ListWrapper>
      </Title>
    </PageTransition>
  );
}

export default Work;
